var n,t;function o(){if(t)return n;t=1;var o="object"==typeof document&&document.all;return n=void 0===o&&void 0!==o?function(n){return"function"==typeof n||n===o}:function(n){return"function"==typeof n}}export{o as __require};
//# sourceMappingURL=is-callable.js.map
